import { FunctionComponent } from 'react'
import ManageTags from './ManageTags/ManageTags'
import ForumThreads from './ManageForums/ForumThreads'
import HandleMembershipApplications from './MembersApplications/HandleMembershipApplications'
import { ManageThreadsProvider } from './ManageForums/ManageThreadsContext'
import { ManageWorkroomsProvider } from './ManageWorkrooms/manageWorkroomContext'
import MyForumThreads from './ManageForums/MyForumThreads'
import UnassignedForumThreads from './ManageForums/UnassignedForumThreads'
import { Col, Row } from 'react-bootstrap'
import HiddenWorkrooms from './ManageWorkrooms/HiddenWorkrooms'
import AllWorkrooms from './ManageWorkrooms/AllWorkrooms'
import NotApprovedWorkrooms from './ManageWorkrooms/NotApprovedWorkrooms'
import { useTranslation } from 'react-i18next'

export enum TypeOfThreads {
  MyThreads = 'MY_THREADS',
  UnassignedThreads = 'UNASSIGNED_THREADS',
  AllThreads = 'ALL_THREADS',
}

interface DashboardProps {
  isAdmin: string
  isModerator: string
}

const CommunityDashboard: FunctionComponent<DashboardProps> = ({ isAdmin, isModerator }) => {
  const { t } = useTranslation()

  return (
    <Row className="mt-3">
      {(isAdmin === 'True' || isModerator === 'True') && (
        <ManageThreadsProvider>
          <h2>{t('dashboard.q-and-a')}</h2>
          <Col md={4}>
            <MyForumThreads />
          </Col>
          <Col md={4}>
            <UnassignedForumThreads />
          </Col>
          <Col md={4}>
            <ForumThreads />
          </Col>
        </ManageThreadsProvider>
      )}
      <h2 className="mt-4">{t('dashboard.tags')}</h2>
      <Col>
        <ManageTags isAdmin={isAdmin === 'True'} isModerator={isModerator === 'True'} />
      </Col>
      {isAdmin === 'True' && (
        <>
          <h2 className="mt-4">{t('dashboard.workrooms.workrooms')}</h2>
          <ManageWorkroomsProvider>
            <Col md={4}>
              <AllWorkrooms />
            </Col>
            <Col md={4}>
              <HiddenWorkrooms />
            </Col>
            <Col md={4}>
              <NotApprovedWorkrooms />
            </Col>
          </ManageWorkroomsProvider>
        </>
      )}
      {isAdmin === 'True' && (
        <>
          <h2 className="mt-4">{t('dashboard.members')}</h2>
          {/* <Col md={6}>
        <DashboardItem heading="Ta bort användare">Ta bort användare</DashboardItem>
      </Col> */}
          {/* <Col sm={4}>
          <DashboardItem heading="Flytta innehåll för användare">Flytta innehåll för användare</DashboardItem>
        </Col> */}
          <Col sm={6}>
            <HandleMembershipApplications />
          </Col>
        </>
      )}
    </Row>
  )
}

export default CommunityDashboard
